<template>
  <div>
    <Nav
      title="积分抽奖"
      right1Items="../../assets/lottery/rule_icon.png"
      right2Items="../../assets/lottery/service_icon.png"
      v-on:right1action="viewRules"
      v-on:right2action="call"
    />

    <div class="lottery_bg">
      <div class="lottery_intergral_bg">
        <p class="lottery_intergral_tit">我的积分</p>
        <p class="lottery_integral_value">{{ integral.toString() }}</p>
        <img
          class="lottery_integral_image"
          src="../../assets/lottery/integral_ing.png"
        />
      </div>
      <lottery-more title="我的幸运码" v-on:moreaction="pushMyLucky" />
      <prize
        class="prize"
        v-if="dataModel != null && dataModel.award != null"
        :prizeIndex="dataModel.num.toString()"
        :prizeName="dataModel.award.name"
        :prizePrice="dataModel.award.price.toString()"
        :prizeImage="dataModel.award.picture"
      />
      <exchange
        v-if="dataModel != null"
        v-on:oneexchange="exchangeEvent(1)"
        v-on:tenexchange="exchangeEvent(10)"
      />
      <div v-if="dataModel != null">
        <div class="lottery_draw" v-if="isDrawStatus == -1">
          很遗憾，您与奖品擦肩而过了。
        </div>
        <div class="lottery_draw" v-if="isDrawStatus == 2">
          <img
            class="lottery_draw_timer"
            src="../../assets/lottery/tz_img.png"
            v-if="timer != null"
          />
          因活动参与人数过少，取消开奖。
        </div>
        <div
          class="lottery_draw lottery_draw_draw_true"
          v-if="isDrawStatus == 1"
          @click="winning(true)"
        >
          <img
            class="lottery_draw_timer"
            src="../../assets/lottery/zj_img.png"
            v-if="timer != null"
          />
          恭喜您，中奖了，去领取 奖品 >
        </div>
        <div
          class="lottery_draw lottery_draw_draw_true"
          v-if="isDrawStatus == 3"
        >
          <img
            class="lottery_draw_timer"
            src="../../assets/lottery/zj_img.png"
            v-if="timer != null"
          />
          恭喜您，已领取奖品！
        </div>
        <div class="lottery_draw" v-if="isDrawStatus == 0">
          <img
            class="lottery_draw_timer"
            src="../../assets/lottery/time.png"
            v-if="timer != null"
          />
          {{ timer }} 开奖
        </div>
        <div class="lottery_draw_timer_msg">{{ msg }}</div>
      </div>
      <lucky-value />
      <algorithm />
      <winners-list />
      <not-draw-toast
        v-if="dataModel != null"
        :minPerson="dataModel.minPerson"
        :toastShow="isShowNotDrawToast"
        v-on:isshowaction="notWinning(false)"
      />
      <draw-address-toast
        v-if="dataModel != null && dataModel.award != null"
        :toastShow="isShowDrawAddressToast"
        :headerTitle="dataModel.award.name"
        v-on:isshowaction="winning(false)"
        @reloadData="reloadData"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Nav from "../../components/nav/Nav.vue";
import LotteryMore from "../../components/lottery/LotteryMore.vue";
import Prize from "../../components/lottery/Prize.vue";
import Exchange from "../../components/lottery/Exchange.vue";
import LuckyValue from "../../components/lottery/LuckyValue.vue";
import Algorithm from "../../components/lottery/Algorithm.vue";
import WinnersList from "../../components/lottery/WinnersList.vue";
import NotDrawToast from "../../components/lottery/NotDrawToast.vue";
import DrawAddressToast from "../../components/lottery/DrawAddressToast.vue";
import { Options, Vue } from "vue-class-component";
import { Http, ResponseData } from "../../net/Http";
import { Urls } from "../../net/Urls";
import { LotteryModel, WinnerModel } from "../../model/lottery/LotteryModel";
import { TimerFormatter } from "../../hooks/TimerFormatter";
import { openToast } from "toast-ts";
import { LotteryConfig } from "../../config/Lottery.conf";
@Options({
  components: {
    Nav,
    LotteryMore,
    Prize,
    Exchange,
    LuckyValue,
    Algorithm,
    WinnersList,
    NotDrawToast,
    DrawAddressToast
  }
})
export default class LotteryPage extends Vue {
  private navRights = [
    "../../assets/lottery/rule_icon.png",
    "../../assets/lottery/service_icon.png"
  ];
  private myLuckyTitle = "我的幸运码";
  /// 是否开奖 //-1:未中奖 0:未开奖 1:中奖 2:取消开奖 3:中奖并已经兑换过奖品
  private isDrawStatus = 0;
  private timer: string | null = "";
  private msg = "本期幸运码兑换截止到本周日零点";
  private dataModel: LotteryModel | null = null;
  private integral = 0;
  private isShowNotDrawToast = false;
  private isShowDrawAddressToast = false;
  private timerInterval: number | null = 0;
  mounted() {
    this.getPoints();
    this.getLotteryData();
  }

  getPoints() {
    Http.get<number>(Urls.getPoints).then(
      (res: number) => {
        this.integral = res;
      },
      (err: ResponseData) => {
        console.log("LotteryPage:", err.message);
        // openToast(err.message);
      }
    );
  }
  getLotteryData() {
    Http.get<LotteryModel>(Urls.lottery_curPhase).then(
      (res: LotteryModel) => {
        this.dataModel = res;
        LotteryConfig.minPerson = this.dataModel.minPerson;
        this.isDrawEvent();
        this.timer = TimerFormatter.lotteryTimerFormatter(
          this.dataModel.drawTime.toString()
        );
      },
      (err: ResponseData) => {
        console.log(Urls.lottery_curPhase, err.message);
      }
    );
  }
  exchangeEvent(num: number) {
    Http.post<string>(Urls.lottery_exchange, { num: num }).then(
      () => {
        this.integral -= num * 100;
        openToast("兑换成功");
      },
      (err: ResponseData) => {
        console.log(Urls.lottery_exchange, err.message);
        if (
          err.code == 22102 ||
          err.code == 22103 ||
          err.code == 22104 ||
          err.code == 20106
        ) {
          openToast(err.message);
        }
      }
    );
  }

  /// 和当前时间对比是否开奖
  isDrawEvent() {
    //  1、先根据时间判断，是否到开奖时间
    if (this.dataModel == null) return;
    const now = new Date();
    const drawTime = new Date(this.dataModel.drawTime.toString());
    // 还没到开奖时间
    if (now < drawTime) {
      // if (this.dataModel.status == 0) {
      this.isDrawStatus = 0;
      this.setIntervalReloadData();
    } else {
      // 到开奖时间了
      this.isDataDraw();
    }
  }
  // 距离开奖3分钟就倒计时
  setIntervalReloadData() {
    if (this.dataModel != null) {
      const drawTime = new Date(this.dataModel.drawTime.toString());
      const now = new Date();
      const seconds = drawTime.getTime() - now.getTime();
      console.log("seconds", seconds);
      if (seconds < 180000 && seconds > 0) {
        this.timerInterval = setInterval(() => {
          if (this.timerInterval != null) {
            clearTimeout(this.timerInterval);
          }
          this.getLotteryData();
        }, seconds + 3000);
      }
    }
  }

  isDataDraw() {
    // 2、根据后台判断，是否开奖
    if (this.dataModel == null) return;
    if (this.dataModel.status == 1) {
      // 开奖了
      this.isWinnerData();
    } else if (this.dataModel.status == -1) {
      // 取消开奖
      this.isDrawStatus = 2;
      this.msg = "本期已停止兑换幸运码";
    }
  }

  /// 是否中奖
  isWinnerData() {
    Http.post<WinnerModel>(Urls.lottery_isWinner, null).then(
      (res: WinnerModel) => {
        if (res.isWinner == false) {
          // 未中奖
          this.isDrawStatus = -1;
          this.notWinning(true);
        } else if (res.isWinner == true) {
          this.redeemPrizes(res.isTook);
        }
      },
      (err: ResponseData) => {
        this.isDrawStatus = -1;
        console.log(Urls.lottery_isWinner, err.message);
        // openToast("获取是否中奖失败");
      }
    );
  }

  // 是否兑换过奖品
  redeemPrizes(isRedeem: boolean) {
    if (isRedeem) {
      //兑换过奖品
      this.isDrawStatus = 3;
    } else {
      // 没有兑换过
      this.isDrawStatus = 1;
      this.defultWinning(true);
    }
  }
  pushMyLucky() {
    this.$router.push("/my/lucky");
  }
  viewRules() {
    this.$router.push("/lottery/rule");
  }
  call() {
    window.location.href = "tel://17331511136";
  }
  notWinning(value: boolean) {
    if (LotteryConfig.getShowWinningToast(LotteryConfig.notWinning)) {
      this.isShowNotDrawToast = value;
    }
  }

  winning(value: boolean) {
    this.isShowDrawAddressToast = value;
  }
  /// isAction：是否是点击，默认弹窗= false
  defultWinning(value: boolean) {
    if (LotteryConfig.getShowWinningToast(LotteryConfig.winning)) {
      this.isShowDrawAddressToast = value;
    }
  }
  reloadData() {
    this.isShowDrawAddressToast = false;
    this.isDrawStatus = 3;
  }
  playVideo() {
    this.$router.push("/video");
  }
  // clear() {
  //   const storage = window.localStorage;
  //   storage.clear();
  // }
}
</script>

<style lang="less">
@import "../../style/BaseStyle.less";
.lottery_bg {
  background-color: #f6f6f6;
  width: 100%;
  position: fixed;
  margin: 0 auto;
  left: 0px;
  bottom: 0;
  top: 44px;
  overflow-y: scroll;
  .lottery_intergral_bg {
    margin: 20px 20px 20px 20px;
    // width: 0%;
    // position: absolute;
    height: 44px;
    background-color: #f64746;
    border-radius: 10px;
    .lottery_intergral_tit {
      margin: 0 auto;
      padding-top: 14px;
      padding-left: 14px;
      float: left;
      text-align: left;
      font-size: 13px;
      color: white;
    }
    .lottery_integral_value {
      // position: absolute;
      height: 44px;
      margin: 0 auto;
      margin-top: 13px;
      line-height: 20px;
      // padding-top: 9px;
      padding-left: 10px;
      float: left;
      text-align: left;
      font-size: 20px;
      color: white;
    }
    .lottery_integral_image {
      height: 100%;
      float: right;
    }
  }
  .prize {
    margin-top: 16px;
  }
  // 开奖
  .lottery_draw_draw_true {
    color: #ff1e1e;
    font-weight: bold;
  }
  .lottery_draw {
    margin: 11px 20px;
    height: 32px;
    width: ~"(100% - 40px)";
    background-color: #ffffff;
    border-radius: 32px;
    text-align: center;
    align-content: center;
    line-height: 32px;
    font-size: 12px;
    .lottery_draw_timer {
      text-indent: 2em;
      height: 22px;
      display: inline-table;
      vertical-align: middle;
      padding-bottom: 4px;
      align-items: center;
    }
  }
  .lottery_draw_timer_msg {
    font-size: 12px;
    color: #888888;
    margin-top: 6px;
  }
}
</style>
